import React from 'react';
// import PropTypes from 'prop-types';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import { IntroGuideSection } from '../../organisms/category/introGuideSection/IntroGuideSection';
import { SystemList } from '../../organisms/category/systemList/SystemList';
import { InfoSection } from '../../organisms/category/infoSection/InfoSection';
import { getDataByType } from '../../../utils/utils';
import PopularCategories from '../../organisms/shared/popularCategories/PopularCategories';
import SystemGuideCard from '../../molecules/category/systemGuideCard/SystemGuideCard';

export const CategoryTop = ({
  hero,
  breadcrumbs,
  sections,
  t,
  menu,
  footer,
  siteUrls,
  location,
  search,
  locale,
}) => {
  const sectionOne = getDataByType(sections, 'sectionOne');
  const cardsData = getDataByType(sections, 'sectionSystemList');
  const sectionThree = getDataByType(sections, 'sectionThree');
  const popularSection = getDataByType(sections, 'popularCategories');

  return (
    <div className="bg-primary-50 overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header
        headerText={hero.title}
        minHeight="350px"
        isLargeWidth
        card={
          <div className="mt-12">
            <SystemGuideCard
              title={hero.card.title}
              description={hero.card.description}
              href={hero.card.url}
              icon={hero.card.icon}
              handleClick={hero.card.handleClick}
              label={hero.card.label}
              linkClassName="min-h-[160px]"
              buttonText={hero.card.buttonText}
            />
          </div>
        }
      />
      <main className="relative">
        <Breadcrumbs levels={breadcrumbs} infoText={t('legal.category.text')} />
        <IntroGuideSection section={sectionOne} t={t} />
        <PopularCategories section={popularSection} t={t} />
        <SystemList
          section={cardsData}
          t={t}
          filter={false}
          showCompareBtn={false}
          locale={locale}
        />
        <InfoSection section={sectionThree} />
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

CategoryTop.propTypes = {
  // hero: PropTypes.object,
  // sections: PropTypes.array,
};
